module.exports = __webpack_public_path__ + "static/img/bg_activity4.924436f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/doubleFestival/3/bg_activity4.png
// module id = TN0W
// module chunks = 1